/** draft: being set up · active: in use · retired: no longer run */
export const ASSAY_STATES = ['draft', 'active', 'retired'];
/** manual: typed into Routine Sample Management · upload: a file through the Upload results page · instrument: a sync job */
export const ASSAY_CAPTURES = ['manual', 'upload', 'instrument'];
export const UPLOAD_MAPPING_VERSION = 1;
const isPlainObject = (v) => typeof v === 'object' && v !== null && !Array.isArray(v);
const nonEmptyString = (v) => typeof v === 'string' && v.trim().length > 0;
/** `sample_types`: a non-empty list of distinct, non-blank sample type names; trimmed. */
export function validateSampleTypes(value) {
    if (!Array.isArray(value))
        return { error: 'sample_types: must be an array of sample type names' };
    const out = [];
    for (let i = 0; i < value.length; i++) {
        const v = value[i];
        if (!nonEmptyString(v))
            return { error: `sample_types[${i}]: must be a non-empty string` };
        const t = v.trim();
        if (out.includes(t))
            return { error: `sample_types: duplicate "${t}"` };
        out.push(t);
    }
    if (out.length === 0)
        return { error: 'sample_types: declare at least one sample type' };
    return { value: out };
}
/** `upload_mapping`: validated and normalised (trimmed strings, unknown properties dropped). */
export function validateUploadMapping(value) {
    if (!isPlainObject(value))
        return { error: 'upload_mapping: must be an object { version, sampleIdColumn, columns }' };
    if (value.version !== UPLOAD_MAPPING_VERSION) {
        return { error: `upload_mapping.version: must be ${UPLOAD_MAPPING_VERSION} (got ${JSON.stringify(value.version)})` };
    }
    if (!nonEmptyString(value.sampleIdColumn))
        return { error: 'upload_mapping.sampleIdColumn: required non-empty string' };
    const out = { version: UPLOAD_MAPPING_VERSION, sampleIdColumn: value.sampleIdColumn.trim(), columns: [] };
    if (value.headerRow !== undefined) {
        if (!Number.isInteger(value.headerRow) || value.headerRow < 1)
            return { error: 'upload_mapping.headerRow: must be an integer >= 1' };
        out.headerRow = value.headerRow;
    }
    if (!Array.isArray(value.columns) || value.columns.length === 0)
        return { error: 'upload_mapping.columns: must be a non-empty array' };
    const seenColumns = new Set();
    const seenKeys = new Set();
    for (let i = 0; i < value.columns.length; i++) {
        const raw = value.columns[i];
        const at = `upload_mapping.columns[${i}]`;
        if (!isPlainObject(raw))
            return { error: `${at}: must be an object { column, key }` };
        if (!nonEmptyString(raw.column))
            return { error: `${at}.column: required non-empty string` };
        if (!nonEmptyString(raw.key))
            return { error: `${at}.key: required non-empty string` };
        const column = raw.column.trim();
        const key = raw.key.trim();
        if (column === out.sampleIdColumn)
            return { error: `${at}.column: "${column}" is the sample id column` };
        if (seenColumns.has(column))
            return { error: `${at}.column: duplicate "${column}"` };
        if (seenKeys.has(key))
            return { error: `${at}.key: duplicate "${key}"` };
        seenColumns.add(column);
        seenKeys.add(key);
        const col = { column, key };
        if (raw.unit !== undefined) {
            if (!nonEmptyString(raw.unit))
                return { error: `${at}.unit: must be a non-empty string when present` };
            col.unit = raw.unit.trim();
        }
        out.columns.push(col);
    }
    return { value: out };
}
